export default __webpack_public_path__ + "static/media/wypozycz.27ea630f.png";